import moment from 'moment-es6'
import {
  ADD_EMAIL_TEMPLATE_TO_ALERT,
  ADD_EMAIL_TEMPLATE_TO_EMAILS_ARRAY,
  HIDE_ADMIN_ALERT_EMAIL_BY_ID,
  POPULATE_ADMIN_ALERT_EMAILS,
  POPULATE_ADMIN_ALERTS,
  SET_ADMIN_ALERT_ACTIVE,
  SET_ADMIN_ALERT_AFFECTED_COUNT,
  SET_ADMIN_ALERT_DATE_RANGE,
  SET_ADMIN_ALERT_DAYS,
  SET_ADMIN_ALERT_EMAIL_EDITED_STATE,
  SET_ADMIN_ALERT_END_DATE,
  SET_ADMIN_ALERT_LAST_UPDATED,
  SET_ADMIN_ALERT_NAME,
  SET_ADMIN_ALERT_SLIDER,
  SET_ADMIN_ALERT_START_DATE,
  SET_ALERT_COURSES,
  SET_ALERT_EDITING,
  SET_ALERT_HIERARCHY_DRAWER_STATE,
  SET_INFORMATION_SNACKBAR_STATE,
  SET_INFORMATION_SNACKBAR_TEXT,
  SET_LAST_DELETED_ADMIN_ALERT_EMAIL_ID,
  SET_UNDO_TYPE,
  SHOW_ADMIN_ALERT_EMAIL_BY_ID,
  TOGGLE_ADMIN_ALERT_STATE,
  UPDATE_ADMIN_ALERT_EMAIL_RECIPIENTS,
  UPDATE_ADMIN_ALERT_EMAIL_TEXT,
  UPDATE_ALERT,
  SET_ALERT_BUTTON_FILTER_TYPE,
  SET_ALERT_LIST_FILTER_TYPE,
  SET_ALERT_LIST_FILTER_ARRAY,
  TOGGLE_ALERTS_FILTER,
  SET_ALERT_ACADEMIC_YEAR,
  SET_ALERT_ENROLMENT_STATUS,
  SET_STUDY_MODE_FOR_ALERT_FROM_CHANGE,
  SET_CUSTOM_ALERT_FILTERS,
  SET_ALERT_FILTER_ID,
  SET_CUSTOM_FILTERS_ARRAY,
  SET_ALERT_BUTTON_FILTER_ARRAY,
  SET_ALERT_CUSTOM_LIST_FILTER_TYPE,
  SET_ALERT_CUSTOM_BUTTON_FILTER_TYPE,
  SET_ALERT_COURSE_LEVEL,
  RESET_ALERT_FILTERS,
  SET_ALERT_ACTIVE_TOGGLE,
  SET_LANDING_ALERTS,
  SET_LANDING_ALERTS_PROGRESS_ON,
  SET_LANDING_ALERTS_PROGRESS_OFF,
  SET_ALERT_PLACEHOLDERS,
  PLACEHOLDER_COPY_TO_CLIPBOARD,
  PLACEHOLDER_RESET_CLIPBOARD,
  SHOW_ALL_TEMPLATES,
  SHOW_ALL_DATA_SETS,
  SELECT_ALL_FREQUENCY,
  SET_SINGLE_ALERT,
  SET_TEMPLATE_ITEM_VISIBILITY,
  SET_DATA_SET_ITEM_VISIBILITY,
  SET_DATA_SET_ITEMS,
  UPDATE_ALERT_DETAILS,
  UPDATE_DATA_SET_PROP,
  RESET_DATA_SET_VALUES,
  CREATE_NEW_DATA_SET_ITEM,
  UNDO_CREATE_NEW_DATA_SET_ITEM,
  UPDATE_NEW_LOGIC_COLOUR_GROUP,
  UPDATE_EXISTING_LOGIC_COLOUR_GROUP,
  SAVE_LAST_DELETED_DATA_SET_ID,
  HIDE_DATA_SET_BY_ID,
  SHOW_DATA_SET_BY_ID,
  UPDATE_TEMPLATE_PROP,
  RESET_SINGLE_ALERT,
  SET_ALERT_END_DATE,
  SET_ALERT_START_DATE,
  SET_ALERT_DETAILS_DESCRIPTION,
  UPDATE_ALERT_LIST,
  SAVE_LAST_DELETED_ALERT_ID,
  SHOW_ALERT_BY_ID,
  HIDE_ALERT_BY_ID,
  SET_STUDENT_AFFECTED_COUNT,
  SET_ALERT_DETAILS_ACTIVE_TOGGLE,
  SAVE_LAST_DELETED_EMAIL_TEMPLATE_ID,
  SHOW_EMAIL_TEMPLATE_BY_ID,
  HIDE_EMAIL_TEMPLATE_BY_ID,
  UNDO_CREATE_NEW_EMAIL_TEMPLATE_ITEM,
  CREATE_NEW_EMAIL_TEMPLATE_ITEM,
  SELECT_FREQUENCY_ITEMS,
  SELECT_ALERT_POSITIVE,
  UPDATE_NEW_EMAIL_TEMPLATE,
  SET_AFFECTED_STUDENTS_PROGRESS_ON,
  SET_AFFECTED_STUDENTS_PROGRESS_OFF,
  SET_DATA_SET_PROPERTIES,
  SET_DATA_SET_PROGRESS_ON,
  SET_DATA_SET_PROGRESS_OFF,
  SET_TEMPLATES_PROGRESS_OFF,
  SET_TEMPLATES_PROGRESS_ON,
  UNDO_CREATE_NEW_TEMPLATE_ITEM,
  SET_ALERT_CONSECUTIVE_DAYS,
  CREATE_NEW_DEFAULT_ALERT,
  SET_ALERT_DATE_RANGE,
  ALERT_DETAILS_PANEL_DISPLAY_FLAG,
  CLEAR_ALERT_FILTERS,
  SET_DRAWER_COMPONENT,
  RESET_INTERVENTION_MODULE,
  RESET_EXEMPTION_MODULE,
  SET_DRAWER_STATE,
  SET_COURSES_FOR_ALERTS_FROM_ENDPOINT,
  SET_COURSES_FOR_ALERTS_FROM_CHANGE,
  SET_ALERT_DETAILS_BODY_PROGRESS_ON,
  SET_ALERT_DETAILS_BODY_PROGRESS_OFF,
  SET_DELIVERY_METHODS,
  SET_ALERT_DESCRIPTION,
  SET_ALERT_ID, CONCAT_TEMPLATE_RECIPIENT_TYPES,
  SET_DRAWER_COMPONENT_TITLE,
  SET_COURSE_HIERARCHY_LOADING
} from '../mutation-types'
import {
  CREATE_ADMIN_ALERT_EMAIL_TEMPLATE,
  DELETE_ADMIN_ALERT_EMAIL,
  GET_ADMIN_ALERTS,
  SAVE_ADMIN_ALERT_EMAIL,
  SEND_ADMIN_ALERT_UPDATE,
  SET_UNDO_STATE_ASYNC,
  SAVE_ADMIN_ALERT_HIERARCHY,
  GET_CUSTOM_FILTERS_FOR_ALERTS,
  GET_ENROLMENT_STATUS_FILTER,
  ALERTS_CHANGE_FILTER,
  ALERTS_CHANGE_LIST_FILTER,
  GET_STUDY_MODES_ALERTS,
  GET_COURSE_YEARS_ALERTS,
  GET_COURSE_LEVELS_ALERTS,
  UPDATE_ALL_ALERT_FILTERS,
  GET_ALERTS_LANDING,
  UPDATE_ALERT_ACTIVE_CRITERIA,
  GET_TEMPLATE_PLACEHOLDERS,
  GET_SINGLE_ALERT,
  GET_DATA_SET_ITEMS,
  UPDATE_DATA_SET_ITEM,
  CREATE_INITIAL_ALERT,
  POST_NEW_DATA_SET_ITEM,
  DELETE_DATA_SET_ITEM,
  COPY_ALERT,
  DELETE_ALERT,
  GET_STUDENT_AFFECTED_COUNT,
  DELETE_EMAIL_TEMPLATE_ITEM,
  EDIT_ALERT_DETAILS,
  UPDATE_EMAIL_TEMPLATE_ITEM,
  POST_NEW_EMAIL_TEMPLATE_ITEM,
  GET_SAVED_FILTERS_FOR_ALERT,
  CLEAR_ALERT_FILTERS_ACTION,
  ORGANISE_ALERT_FILTERS,
  GET_COURSES_FOR_ALERTS,
  ORGANISE_ALERT_FILTERS_CHECK_LIST,
  ALERT_FILTER_DRAWER,
  GET_DELIVERY_METHODS,
  GET_ALL_COURSES_FOR_ALERTS
} from '../action-types'
import { GET_ALERT } from '../getter-types'
import axios from 'axios/index'
import { ratingMap } from './studentModule'
import Vue from 'vue'
import { informationTexts } from './information'
import { undoTypes } from './undo'
import { clearFilters, getAppliedFilters } from '../../HelperMethods'
import router from '../../router'
import { components, componentTitles } from './rightDrawer'

const format = 'YYYY-MM-DD'
const timeFormat = 'YYYY-MM-DD, HH:mm:ss'
const state = {
  alerts: {},
  alertEmails: {
    1: {
      id: 1,
      recipients: [0, 1],
      text: ''
    },
    2: {
      id: 2,
      recipients: [0],
      text: ''
    }
  },
  alertHierarchyDrawer: false,
  alertId: null,
  lastDeletedAlertEmailId: null,
  customFilters: {},
  filterFields: {},
  customListSources: {},
  listSources: {},
  newAlerts: [],
  newSingleAlert: {},
  newAlertId: null,
  landingAlertsLoading: false,
  dataSetSelectionItems: [],
  placeholders: [],
  deliveryMethods: [],
  lastDeletedDataSetId: null,
  lastDeletedAlertId: null,
  studentAffectedCount: -1,
  studentAffectedCountLoading: false,
  lastDeletedEmailTemplateId: null,
  dataSetsLoading: false,
  templatesLoading: false,
  courseHierarchyLoading: false,
  alertDetailsBodyLoading: false,
  alertDetailsDisplayFlag: true,
  alertFilterFields: {
    courseIds: {
      header: 'student.filters.headers.courses',
      isList: true,
      listName: 'courseIds',
      values: {},
      courses: []
    }
  },
  alertListSources: {
    courseIds: {
      identifier: 'course',
      title_i18n: 'student.filters.course_selection',
      items: [],
      idValues: {},
      button_i18n: 'student.filters.courses_button',
      button_unselected_i18n: 'student.filters.courses_button_unselected',
      containsText (item, text) {
        return (item.courseDescription.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
          (item.courseIdentifier.toUpperCase().indexOf(text.toUpperCase()) >= 0)
      },
      key (item) {
        return item.courseIdentifier
      },
      mapRow (item) {
        return {
          rows: [item.courseDescription, item.courseIdentifier],
          id: item.id
        }
      }
    }
  },
  templateRecipientTypes: [
    {
      text: 'admin.alerts.new.email_templates.recipients.student',
      value: 'STUDENT'
    }, {
      text: 'admin.alerts.new.email_templates.recipients.tutor',
      value: 'STAFF'
    }
  ]
}

const actions = {
  [GET_ALERTS_LANDING] ({rootState, state, commit}) {
    commit(SET_LANDING_ALERTS_PROGRESS_ON)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/summary/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: GET_ALERTS_LANDING}
    }).then((res) => {
      commit(SET_LANDING_ALERTS, res.data)
      commit(SET_LANDING_ALERTS_PROGRESS_OFF)
    }).catch((err) => {
      console.log('Failed to get alerts')
      console.error(err)
      commit(SET_LANDING_ALERTS_PROGRESS_OFF)
    })
  },
  [CREATE_INITIAL_ALERT] ({rootState, state, commit}, alert) {
    let payload = alert
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/create`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: payload,
      actionData: {action: CREATE_INITIAL_ALERT, data: payload}
    }).then((res) => {
      commit(UPDATE_ALERT_LIST, res.data)
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ALERT_CREATED)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      commit(ALERT_DETAILS_PANEL_DISPLAY_FLAG, true)
      router.push({name: 'AlertDetails', params: {id: res.data.id}})
      window.location.reload()
    }).catch((err) => {
      console.log('Failed to create initial alert')
      console.error(err)
    })
  },
  [COPY_ALERT] ({rootState, state, commit}, alertId) {
    let payload = alertId
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/${alertId}/copy`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: payload,
      actionData: {action: COPY_ALERT, data: payload}
    }).then((res) => {
      commit(UPDATE_ALERT_LIST, res.data)
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ALERT_COPIED)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      router.push({name: 'AlertDetails', params: {id: res.data.id}})
    }).catch((err) => {
      console.log('Failed to copy alert')
      console.error(err)
    })
  },
  [DELETE_ALERT] ({rootState, state, commit, dispatch}, {alertId, toBeDeleted}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/${alertId}/delete/${toBeDeleted}`,
      method: 'delete',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: DELETE_ALERT, data: {alertId, toBeDeleted}}
    }).then(() => {
      if (toBeDeleted) {
        commit(SAVE_LAST_DELETED_ALERT_ID, alertId)
        commit(SET_UNDO_TYPE, undoTypes.ALERT_DELETED)
        dispatch(SET_UNDO_STATE_ASYNC, true)
        commit(HIDE_ALERT_BY_ID, alertId)
        router.push({name: 'AdminAlerts'})
      } else {
        dispatch(SET_UNDO_STATE_ASYNC, false)
        commit(SHOW_ALERT_BY_ID, alertId)
      }
    }).catch((err) => {
      if (toBeDeleted) {
        console.log('Failed to delete alert')
        console.error(err)
      } else {
        console.log('Failed to undo delete alert')
        console.error(err)
      }
    })
  },
  [GET_STUDENT_AFFECTED_COUNT] ({rootState, state, commit}, alertId) {
    commit(SET_AFFECTED_STUDENTS_PROGRESS_ON)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/affected/count/${alertId}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: GET_STUDENT_AFFECTED_COUNT}
    }).then((res) => {
      commit(SET_STUDENT_AFFECTED_COUNT, res.data)
      commit(SET_AFFECTED_STUDENTS_PROGRESS_OFF)
    }).catch((err) => {
      console.log('Failed to get student affected count')
      console.error(err)
      commit(SET_AFFECTED_STUDENTS_PROGRESS_OFF)
    })
  },
  [GET_SINGLE_ALERT] ({rootState, state, commit}, alertId) {
    commit(SET_DATA_SET_PROGRESS_ON)
    commit(SET_TEMPLATES_PROGRESS_ON)
    commit(SET_ALERT_DETAILS_BODY_PROGRESS_ON)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/get/${alertId}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: GET_SINGLE_ALERT}
    }).then((res) => {
      if (res.data.deleted) {
        router.push({name: 'AdminAlerts'})
      } else {
        res.data.dataSets = !res.data.dataSets ? [] : res.data.dataSets
        res.data.emailTemplates = !res.data.emailTemplates ? [] : res.data.emailTemplates
        res.data.frequencyDays = !res.data.frequencyDays ? [] : res.data.frequencyDays

        res.data.dataSets.forEach(el => {
          setDataSetDefaults(el)
        })
        res.data.emailTemplates.forEach(el => {
          commit(CONCAT_TEMPLATE_RECIPIENT_TYPES, mapFreestyleRecipients(el.emailRecipients))
          setTemplateDefaults(el)
        })
        serverToLocaleCustomFilters(res.data)
        commit(SET_SINGLE_ALERT, res.data)
        commit(SET_DATA_SET_PROGRESS_OFF)
        commit(SET_TEMPLATES_PROGRESS_OFF)
        commit(SET_ALERT_DETAILS_BODY_PROGRESS_OFF)
      }
    }).catch((err) => {
      console.log('Failed to get data sets')
      console.error(err)
      commit(SET_DATA_SET_PROGRESS_OFF)
      commit(SET_TEMPLATES_PROGRESS_OFF)
      commit(SET_ALERT_DETAILS_BODY_PROGRESS_OFF)
      router.push({name: 'AdminAlerts'})
    })
  },
  [GET_DATA_SET_ITEMS] ({rootState, state, commit}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/datasets`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: GET_DATA_SET_ITEMS}
    }).then((res) => {
      commit(SET_DATA_SET_ITEMS, res.data)
    }).catch((err) => {
      console.log('Failed to get data sets')
      console.error(err)
    })
  },
  [POST_NEW_DATA_SET_ITEM] ({rootState, state, commit, dispatch}, alert) {
    const payload = dataSetToServer(alert.dataSet)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/${alert.id}/dataset/create`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: payload,
      actionData: { action: POST_NEW_DATA_SET_ITEM, data: payload }
    }).then(() => {
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.SUBMITTED_DATA_SET)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      dispatch(GET_SINGLE_ALERT, state.newSingleAlert.id)
    }).catch((err) => {
      console.log('Failed to submit new data set')
      console.error(err)
    })
  },
  [POST_NEW_EMAIL_TEMPLATE_ITEM] ({rootState, state, commit}, alert) {
    const payload = convertEmailToServer(alert.emailTemplate)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/${alert.id}/email_template`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: payload,
      actionData: { action: POST_NEW_EMAIL_TEMPLATE_ITEM, data: payload }
    }).then((res) => {
      commit(UPDATE_NEW_EMAIL_TEMPLATE, res.data)
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.SUBMITTED_EMAIL_TEMPLATE)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
    }).catch((err) => {
      console.log('Failed to submit new email template')
      console.error(err)
    })
  },
  [UPDATE_DATA_SET_ITEM] ({rootState, state, commit, dispatch}, alert) {
    const payload = dataSetToServer(Object.assign({}, alert.dataSet))
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/dataset/update/${alert.dataSetId}`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: payload,
      actionData: {action: UPDATE_DATA_SET_ITEM, data: payload}
    }).then(() => {
      dispatch(GET_SINGLE_ALERT, state.newSingleAlert.id)
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.SUBMITTED_DATA_SET)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
    }).catch((err) => {
      console.log('Failed to submit new data set')
      console.error(err)
    })
  },
  [UPDATE_EMAIL_TEMPLATE_ITEM] ({rootState, state, commit}, alert) {
    const payload = convertEmailToServer(alert.emailTemplate)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/email_template/${alert.emailTemplateId}`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: payload,
      actionData: {action: UPDATE_EMAIL_TEMPLATE_ITEM, data: payload}
    }).then((res) => {
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.SUBMITTED_EMAIL_TEMPLATE)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
    }).catch((err) => {
      console.log('Failed to submit new email template')
      console.error(err)
    })
  },
  [EDIT_ALERT_DETAILS] ({rootState, state, commit}, {alert}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/${alert.id}`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: EDIT_ALERT_DETAILS, data: alert.id},
      data: alert
    }).then((res) => {
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ALERT_UPDATED)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
    }).catch((err) => {
      console.log('Failed to update alert')
      console.error(err)
    })
  },
  [DELETE_EMAIL_TEMPLATE_ITEM] ({rootState, state, commit, dispatch}, alert) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/email_template/${alert.id}/delete/${alert.toBeDeleted}`,
      method: 'delete',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: DELETE_EMAIL_TEMPLATE_ITEM, data: alert}
    }).then(() => {
      if (alert.toBeDeleted) {
        commit(SAVE_LAST_DELETED_EMAIL_TEMPLATE_ID, alert.id)
        commit(SET_UNDO_TYPE, undoTypes.EMAIL_TEMPLATE_DELETED)
        dispatch(SET_UNDO_STATE_ASYNC, true)
        commit(HIDE_EMAIL_TEMPLATE_BY_ID, alert.id)
      } else {
        dispatch(SET_UNDO_STATE_ASYNC, false)
        commit(SHOW_EMAIL_TEMPLATE_BY_ID, alert.id)
      }
    }).catch((err) => {
      if (alert.toBeDeleted) {
        console.log('Failed to delete email template')
        console.error(err)
      } else {
        console.log('Failed to undo delete email template')
        console.error(err)
      }
    })
  },
  [DELETE_DATA_SET_ITEM] ({rootState, state, commit, dispatch}, alert) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/dataset/${alert.id}/delete/${alert.toBeDeleted}`,
      method: 'delete',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: DELETE_DATA_SET_ITEM, data: alert}
    }).then(() => {
      if (alert.toBeDeleted) {
        commit(SAVE_LAST_DELETED_DATA_SET_ID, alert.id)
        commit(SET_UNDO_TYPE, undoTypes.DATA_SET_DELETED)
        dispatch(SET_UNDO_STATE_ASYNC, true)
      } else {
        dispatch(SET_UNDO_STATE_ASYNC, false)
      }
      dispatch(GET_SINGLE_ALERT, state.newSingleAlert.id)
    }).catch((err) => {
      if (alert.toBeDeleted) {
        console.log('Failed to delete data set')
        console.error(err)
      } else {
        console.log('Failed to undo delete data set')
        console.error(err)
      }
    })
  },
  [UPDATE_ALERT_ACTIVE_CRITERIA] ({rootState, state, commit}, {alertId, active}) {
    const payload = { alertId, active }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/${alertId}/active/${active}`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: UPDATE_ALERT_ACTIVE_CRITERIA, data: payload}
    }).then((res) => {
      if (active) {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ALERT_ACTIVATED)
      } else {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ALERT_DEACTIVATED)
      }
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
    }).catch((err) => {
      console.log('Failed to activate/deactivate alert')
      console.error(err)
    })
  },
  [GET_TEMPLATE_PLACEHOLDERS] ({rootState, state, commit}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/placeholders`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: GET_TEMPLATE_PLACEHOLDERS}
    }).then((res) => {
      res.data.forEach(el => {
        el.clipped = false
      })
      commit(SET_ALERT_PLACEHOLDERS, res.data)
    }).catch((err) => {
      console.log('Failed to get placeholders')
      console.error(err)
    })
  },
  [GET_DELIVERY_METHODS] ({rootState, state, commit}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/deliverymethods`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: GET_DELIVERY_METHODS}
    }).then((res) => {
      let obj = res.data.map(el => {
        return {
          value: el.code,
          text: el.description
        }
      })
      commit(SET_DELIVERY_METHODS, obj)
    }).catch((err) => {
      console.log('Failed to get delivery methods')
      console.error(err)
    })
  },
  [GET_ALL_COURSES_FOR_ALERTS] ({commit, rootState, dispatch}) {
    const actionData = { action: GET_ALL_COURSES_FOR_ALERTS, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/course/list/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        commit(SET_COURSES_FOR_ALERTS_FROM_ENDPOINT, res.data)
        dispatch(GET_STUDY_MODES_ALERTS)
      })
      .catch((err) => {
        console.log('Failed to get courses for alerts')
        console.error(err)
        dispatch(GET_STUDY_MODES_ALERTS)
      })
  },
  [GET_COURSES_FOR_ALERTS] ({commit, rootState, dispatch}) {
    const actionData = { action: GET_COURSES_FOR_ALERTS, data: undefined }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/course/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        commit(SET_COURSES_FOR_ALERTS_FROM_ENDPOINT, res.data)
        dispatch(GET_STUDY_MODES_ALERTS)
      })
      .catch((err) => {
        console.log('Failed to get courses for alerts')
        console.error(err)
        dispatch(GET_STUDY_MODES_ALERTS)
      })
  },
  [GET_STUDY_MODES_ALERTS] ({commit, dispatch, rootState}) {
    const actionData = {action: GET_STUDY_MODES_ALERTS, data: undefined}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/studymode/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filterObject = {
          filterIdentifier: 'studyModes',
          filterName: 'student.filters.headers.study_mode',
          filterAdditionalDescription: 'student.filters.headers.study_mode_additional_description'
        }
        if (res.data.length > 6) {
          commit(SET_ALERT_LIST_FILTER_TYPE, {status: res.data, alertFilterObject: filterObject})
        } else {
          commit(SET_ALERT_BUTTON_FILTER_TYPE, {status: res.data, alertFilterObject: filterObject})
        }
        dispatch(GET_COURSE_YEARS_ALERTS)
      })
      .catch((err) => {
        console.log('Failed to get study mode filters')
        console.error(err)
        dispatch(GET_COURSE_YEARS_ALERTS)
      })
  },
  [GET_COURSE_YEARS_ALERTS] ({commit, dispatch, rootState}) {
    const actionData = {action: GET_COURSE_YEARS_ALERTS, data: undefined}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/courseyear/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filterObject = {
          filterIdentifier: 'courseYears',
          filterName: 'student.filters.headers.year',
          filterAdditionalDescription: 'student.filters.headers.year_additional_description'
        }
        if (res.data.length > 6) {
          commit(SET_ALERT_LIST_FILTER_TYPE, {status: res.data, alertFilterObject: filterObject})
        } else {
          commit(SET_ALERT_BUTTON_FILTER_TYPE, {status: res.data, alertFilterObject: filterObject})
        }
        dispatch(GET_COURSE_LEVELS_ALERTS)
      })
      .catch((err) => {
        console.log('Failed to get study mode filters')
        console.error(err)
        dispatch(GET_COURSE_LEVELS_ALERTS)
      })
  },
  [GET_COURSE_LEVELS_ALERTS] ({commit, dispatch, rootState}) {
    const actionData = {action: GET_COURSE_LEVELS_ALERTS, data: undefined}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/course/courselevel/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filterObject = {
          filterIdentifier: 'courseLevels',
          filterName: 'student.filters.headers.level',
          filterAdditionalDescription: 'student.filters.headers.level_additional_description'
        }
        if (res.data.length > 6) {
          commit(SET_ALERT_LIST_FILTER_TYPE, {status: res.data, alertFilterObject: filterObject})
        } else {
          commit(SET_ALERT_BUTTON_FILTER_TYPE, {status: res.data, alertFilterObject: filterObject})
        }
        dispatch(GET_ENROLMENT_STATUS_FILTER)
      })
      .catch((err) => {
        console.log('Failed to get course levels alert filter')
        console.error(err)
        dispatch(GET_ENROLMENT_STATUS_FILTER)
      })
  },
  [GET_ENROLMENT_STATUS_FILTER] ({commit, dispatch, rootState}) {
    const actionData = {action: GET_ENROLMENT_STATUS_FILTER, data: undefined}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/enrolmentstatus/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filterObject = {
          filterIdentifier: 'enrolmentStatus',
          filterName: 'student.filters.headers.enrolment_status',
          filterAdditionalDescription: 'student.filters.headers.enrolment_status_additional_description'
        }
        if (res.data.length > 6) {
          commit(SET_ALERT_LIST_FILTER_TYPE, {status: res.data, alertFilterObject: filterObject})
        } else {
          commit(SET_ALERT_BUTTON_FILTER_TYPE, {status: res.data, alertFilterObject: filterObject})
        }
        dispatch(GET_CUSTOM_FILTERS_FOR_ALERTS)
      })
      .catch((err) => {
        console.log('Failed to get enrolment status filters')
        console.error(err)
        dispatch(GET_CUSTOM_FILTERS_FOR_ALERTS)
      })
  },
  [GET_CUSTOM_FILTERS_FOR_ALERTS] ({state, commit, dispatch, rootState}) {
    const actionData = {action: GET_CUSTOM_FILTERS_FOR_ALERTS, data: undefined}
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/filter/alert/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let filters = res.data
        Object.keys(filters).forEach((filter) => {
          let filterIdentifier = filters[filter].filterIdentifier
          if (filters[filter].filterStyle === 'button') {
            commit(SET_ALERT_CUSTOM_BUTTON_FILTER_TYPE, {filters, filter, filterIdentifier})
          } else {
            commit(SET_ALERT_CUSTOM_LIST_FILTER_TYPE, {filters, filter, filterIdentifier})
          }
        })
        dispatch(GET_SINGLE_ALERT, state.newAlertId)
      })
      .catch((err) => {
        dispatch(GET_SINGLE_ALERT, state.newAlertId)
        console.log('Failed to get custom filters')
        console.error(err)
      })
  },
  [ALERTS_CHANGE_FILTER] ({commit, dispatch, state}, filterObject) {
    commit(TOGGLE_ALERTS_FILTER, filterObject)
  },
  [ALERTS_CHANGE_LIST_FILTER] ({commit, dispatch}, filterObject) {
    commit(SET_ALERT_LIST_FILTER_ARRAY, filterObject)
  },
  [CLEAR_ALERT_FILTERS_ACTION] ({commit, state}) {
    // clear all alert filters
    commit(CLEAR_ALERT_FILTERS)

    // clear list types
    Object.keys(state.alertListSources).forEach((filterType) => {
      commit(SET_ALERT_LIST_FILTER_ARRAY, {filterName: [], filterType: filterType})
    })
  },
  [GET_SAVED_FILTERS_FOR_ALERT] ({commit, dispatch}) {
    dispatch(CLEAR_ALERT_FILTERS_ACTION)
    dispatch(ORGANISE_ALERT_FILTERS)
  },
  [ORGANISE_ALERT_FILTERS] ({commit, rootState, dispatch, state}) {
    let alert = state.newSingleAlert
    let filterKeys = Object.keys(state.alertFilterFields)
    filterKeys.push('filters')

    Object.keys(alert).forEach(key => {
      if (filterKeys.includes(key)) {
        if (key === 'filters') {
          alert[key].forEach(el => {
            dispatch(ORGANISE_ALERT_FILTERS_CHECK_LIST, {key: el.filterIdentifier, filterName: el.filterCodes})
          })
        } else {
          dispatch(ORGANISE_ALERT_FILTERS_CHECK_LIST, {key: key, filterName: alert[key]})
        }
      }
    })
    dispatch(ALERT_FILTER_DRAWER)
  },
  [ORGANISE_ALERT_FILTERS_CHECK_LIST] ({dispatch, state}, {key, filterName}) {
    let filters = state.alertFilterFields

    if (filters[key].isList) {
      dispatch(ALERTS_CHANGE_LIST_FILTER, {filterName: filterName, filterType: key})
    } else {
      filterName.forEach(el => {
        dispatch(ALERTS_CHANGE_FILTER, {filterName: el, filterType: key})
      })
    }
  },
  [ALERT_FILTER_DRAWER] ({rootState, commit}) {
    if (!rootState.rightDrawer.state) {
      commit(SET_DRAWER_COMPONENT, components.ALERT_FILTER)
      commit(SET_DRAWER_COMPONENT_TITLE, componentTitles.ALERT_FILTER)
      commit(RESET_INTERVENTION_MODULE)
      commit(RESET_EXEMPTION_MODULE)
      commit(SET_DRAWER_STATE, true)
    }
  },
  /*
  **
  **
  **
  **
  **
  **
  **
  **
  TODO: SORT OLD CODE BELOW
  */
  [GET_ADMIN_ALERTS] ({rootState, state, commit, dispatch}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/all`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: GET_ADMIN_ALERTS}
    }).then((res) => {
      // set filter objects per alert
      commit(SET_ALERT_FILTER_ID, res.data)

      // get filters via endpoints
      dispatch(GET_CUSTOM_FILTERS_FOR_ALERTS, res.data)
    }).catch((err) => {
      console.log('Failed to get alerts')
      console.error(err)
    })
  },
  [SEND_ADMIN_ALERT_UPDATE] ({rootState, state, commit}, id) {
    const payload = localToServer(Object.assign({}, state.alerts[id]))
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/${id}`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: SEND_ADMIN_ALERT_UPDATE, data: id},
      data: payload
    }).then((res) => {
      commit(SET_ADMIN_ALERT_LAST_UPDATED, {lastUpdate: res.data.lastUpdated, id: res.data.id})
      commit(SET_ADMIN_ALERT_AFFECTED_COUNT, {affected: res.data.studentsAffectedCount, id: res.data.id})
    }).catch((err) => {
      console.log('Failed to update alert')
      console.error(err)
    })
  },
  [SAVE_ADMIN_ALERT_HIERARCHY] ({rootState, state, commit, dispatch}, {hierarchyClassIds, alertId}) {
    commit(SET_ALERT_COURSES, hierarchyClassIds)
    return new Promise((resolve, reject) => {
      const payload = localToServer(Object.assign({}, state.alerts[alertId]))
      axios({
        url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/${alertId}`,
        method: 'put',
        headers: {
          'Authorization': rootState.profile.loginToken
        },
        data: payload,
        actionData: {action: SAVE_ADMIN_ALERT_HIERARCHY, data: {hierarchyClassIds, alertId}}
      }).then((res) => {
        commit(SET_ADMIN_ALERT_LAST_UPDATED, {lastUpdate: res.data.lastUpdated, id: res.data.id})
        commit(SET_ADMIN_ALERT_AFFECTED_COUNT, {affected: res.data.studentsAffectedCount, id: res.data.id})
        commit(UPDATE_ALERT, res.data) // Update the version in the store
        dispatch(UPDATE_ALL_ALERT_FILTERS, res.data)
        commit(SET_ALERT_HIERARCHY_DRAWER_STATE, false)
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ALERTS_COURSE_UPDATED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        resolve(res.data)
      }).catch((err) => {
        console.log('Failed to update alert')
        console.error(err)
        reject(err)
      })
    })
  },
  [CREATE_ADMIN_ALERT_EMAIL_TEMPLATE] ({rootState, commit}, alertId) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/${alertId}/email_template`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: {
        emailRecipients: [],
        templateText: ''
      },
      actionData: {action: CREATE_ADMIN_ALERT_EMAIL_TEMPLATE, data: alertId}
    }).then((res) => {
      res.data.alertId = alertId
      commit(ADD_EMAIL_TEMPLATE_TO_EMAILS_ARRAY, res.data)
      commit(ADD_EMAIL_TEMPLATE_TO_ALERT, res.data)
    }).catch((err) => {
      console.log(`Failed create email template for alert with id ${alertId}`)
      console.error(err)
    })
  },
  [SAVE_ADMIN_ALERT_EMAIL] ({rootState, state, commit}, emailId) {
    const payload = localEmailToServer(state.alertEmails[emailId])
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/email_template/${emailId}`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: payload,
      actionData: {action: SAVE_ADMIN_ALERT_EMAIL, data: emailId}
    }).then((res) => {
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ALERT_EMAIL_SAVED)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      commit(SET_ADMIN_ALERT_EMAIL_EDITED_STATE, {emailId: emailId, edited: false})
    }).catch((err) => {
      console.log(`Failed save email template with id ${emailId}`)
      console.error(err)
    })
  },
  [DELETE_ADMIN_ALERT_EMAIL] ({rootState, state, commit, dispatch}, {emailId, toBeDeleted}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/alert/email_template/${emailId}/delete/${toBeDeleted}`,
      method: 'delete',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: DELETE_ADMIN_ALERT_EMAIL, data: {emailId, toBeDeleted}}
    }).then(() => {
      if (toBeDeleted) {
        commit(HIDE_ADMIN_ALERT_EMAIL_BY_ID, emailId)
        commit(SET_LAST_DELETED_ADMIN_ALERT_EMAIL_ID, emailId)
        commit(SET_UNDO_TYPE, undoTypes.ADMIN_ALERT_EMAIL_DELETION)
        dispatch(SET_UNDO_STATE_ASYNC, true)
      } else {
        commit(SHOW_ADMIN_ALERT_EMAIL_BY_ID, emailId)
        dispatch(SET_UNDO_STATE_ASYNC, false)
      }
    }).catch((err) => {
      console.log(`Failed delete email template with id ${emailId}`)
      console.error(err)
    })
  },
  [UPDATE_ALL_ALERT_FILTERS] ({commit, dispatch}, alert) {
    // populate custom filterCodes i.e. campus
    if (alert.filterCodes) {
      let filterIdentifiers = {}
      Object.keys(alert.filterCodes).forEach((filterCodeKey) => {
        let filterIdentifierKey = alert.filterCodes[filterCodeKey].filterIdentifier
        if (state.filterFields[alert.id][filterIdentifierKey]) {
          let filterCode = alert.filterCodes[filterCodeKey]
          if (!filterIdentifiers[filterCode.filterIdentifier]) {
            filterIdentifiers[filterCode.filterIdentifier] = [filterCode.code]
          } else {
            filterIdentifiers[filterCode.filterIdentifier].push(filterCode.code)
          }
        }
      })
      // reset state.alerts.filters if filters have been applied
      if (filterIdentifiers) {
        commit(RESET_ALERT_FILTERS, {id: alert.id})
      }
      Object.keys(filterIdentifiers).forEach((identifierKey) => {
        let alertFilterObject = {
          object: filterIdentifiers[identifierKey],
          key: identifierKey,
          alertId: alert.id
        }
        commit(SET_CUSTOM_FILTERS_ARRAY, alertFilterObject)
        // if list
        if (state.filterFields[alert.id][identifierKey].isList) {
          let filterObject = {
            filterName: filterIdentifiers[identifierKey],
            filterType: identifierKey,
            filterId: alert.id
          }
          commit(SET_ALERT_LIST_FILTER_ARRAY, filterObject)
        }
      })
    }

    // populate other filters if they are a 'list' type
    Object.keys(state.filterFields[alert.id]).forEach((filterField) => {
      if (alert[filterField]) {
        if (state.filterFields[alert.id][filterField].isList) {
          let filterObject = {
            filterName: alert[filterField],
            filterType: filterField,
            filterId: alert.id
          }
          commit(SET_ALERT_LIST_FILTER_ARRAY, filterObject)
        }
      }
    })
  }
}

const mutations = {
  [SET_ALERT_ID] (state, id) {
    state.newAlertId = id
  },
  [UPDATE_ALERT_DETAILS] (state, alert) {
    state.newSingleAlert[alert.key] = alert.value
  },
  [SET_SINGLE_ALERT] (state, alert) {
    state.newSingleAlert = alert
  },
  [RESET_SINGLE_ALERT] (state, alert) {
    state.newSingleAlert = {}
    state.studentAffectedCount = -1
  },
  [UPDATE_ALERT_LIST] (state, item) {
    let element = {}
    element['id'] = item.id
    element['description'] = item.name
    element['active'] = item.active
    state.newAlerts.push(element)
  },
  [SET_ALERT_START_DATE] (state, value) {
    state.startDate = value
  },
  [SET_ALERT_END_DATE] (state, value) {
    state.endDate = value
  },
  [SET_ALERT_DESCRIPTION] (state, alert) {
    state.newAlerts.filter(el => el.id === alert.alertId)[0].description = alert.description
  },
  [SET_ALERT_DETAILS_DESCRIPTION] (state, value) {
    state.newSingleAlert.name = value
  },
  [ALERT_DETAILS_PANEL_DISPLAY_FLAG] (state, value) {
    state.alertDetailsDisplayFlag = value
  },
  [SET_LANDING_ALERTS] (state, alerts) {
    alerts.forEach(el => {
      el.isHidden = false
    })
    state.newAlerts = alerts
  },
  [RESET_DATA_SET_VALUES] (state, key) {
    Object.keys(resetAlert()).forEach(el => {
      state.newSingleAlert.dataSets[key][el] = resetAlert()[el]
    })
  },
  [CREATE_NEW_DATA_SET_ITEM] (state) {
    state.newSingleAlert.dataSets.push(newDataSet())
  },
  [UNDO_CREATE_NEW_DATA_SET_ITEM] (state) {
    state.newSingleAlert.dataSets.pop()
  },
  [UNDO_CREATE_NEW_TEMPLATE_ITEM] (state) {
    state.newSingleAlert.emailTemplates.pop()
  },
  [CREATE_NEW_EMAIL_TEMPLATE_ITEM] (state) {
    state.newSingleAlert.emailTemplates.push(newEmailTemplate())
  },
  [CREATE_NEW_DEFAULT_ALERT] (state) {
    state.newSingleAlert = newDefaultAlert()
  },
  [SET_ALERT_DATE_RANGE] (state, {dateRange}) {
    state.newSingleAlert.effectiveFromDateInclusive = dateRange.startDate
    state.newSingleAlert.endDateExclusive = dateRange.endDate
  },
  [UNDO_CREATE_NEW_EMAIL_TEMPLATE_ITEM] (state) {
    state.newSingleAlert.emailTemplates.pop()
  },
  [SET_ALERT_ACTIVE_TOGGLE] (state, alert) {
    state.newAlerts.filter(el => el.id === alert.alertId)[0].active = alert.active
  },
  [SET_ALERT_DETAILS_ACTIVE_TOGGLE] (state, active) {
    state.newSingleAlert.active = active
  },
  [SET_LANDING_ALERTS_PROGRESS_ON] (state) {
    state.landingAlertsLoading = true
  },
  [SET_LANDING_ALERTS_PROGRESS_OFF] (state) {
    state.landingAlertsLoading = false
  },
  [SET_AFFECTED_STUDENTS_PROGRESS_ON] (state) {
    state.studentAffectedCountLoading = true
  },
  [SET_AFFECTED_STUDENTS_PROGRESS_OFF] (state) {
    state.studentAffectedCountLoading = false
  },
  [SET_COURSE_HIERARCHY_LOADING] (state, flag) {
    state.courseHierarchyLoading = flag
  },
  [SET_DATA_SET_PROGRESS_ON] (state) {
    state.dataSetsLoading = true
  },
  [SET_DATA_SET_PROGRESS_OFF] (state) {
    state.dataSetsLoading = false
  },
  [SET_TEMPLATES_PROGRESS_ON] (state) {
    state.templatesLoading = true
  },
  [SET_TEMPLATES_PROGRESS_OFF] (state) {
    state.templatesLoading = false
  },
  [SET_ALERT_DETAILS_BODY_PROGRESS_ON] (state) {
    state.alertDetailsBodyLoading = true
  },
  [SET_ALERT_DETAILS_BODY_PROGRESS_OFF] (state) {
    state.alertDetailsBodyLoading = false
  },
  [SET_ALERT_PLACEHOLDERS] (state, placeholders) {
    state.placeholders = placeholders
  },
  [SET_DELIVERY_METHODS] (state, methods) {
    state.deliveryMethods = methods
  },
  [PLACEHOLDER_COPY_TO_CLIPBOARD] (state, placeholder) {
    state.placeholders.filter(el => el.id === placeholder.id)[0].clipped = placeholder.clipped
  },
  [PLACEHOLDER_RESET_CLIPBOARD] (state) {
    Object.keys(state.placeholders).forEach(el => {
      state.placeholders[el].clipped = false
    })
  },
  [SELECT_ALL_FREQUENCY] (state, all) {
    if (all) {
      state.newSingleAlert.frequencyDays = ['1', '2', '3', '4', '5', '6', '7']
    } else {
      state.newSingleAlert.frequencyDays = []
    }
  },
  [SELECT_FREQUENCY_ITEMS] (state, val) {
    state.newSingleAlert.frequencyDays = val
  },
  [SET_ALERT_CONSECUTIVE_DAYS] (state, val) {
    state.newSingleAlert.consecutiveDays = val
  },
  [SELECT_ALERT_POSITIVE] (state, val) {
    state.newSingleAlert.positive = val
  },
  [SET_DATA_SET_ITEMS] (state, items) {
    state.dataSetSelectionItems = items
  },
  [UPDATE_EXISTING_LOGIC_COLOUR_GROUP] (state, dataSet) {
    state.newSingleAlert.dataSets.filter(el => el.id === dataSet.id)[0].logicColour = dataSet.logicColour
  },
  [UPDATE_NEW_LOGIC_COLOUR_GROUP] (state, dataSet) {
    state.newSingleAlert.dataSets.filter(el => el.id === dataSet.id)[0].logicColour = dataSet.logicColour
  },
  [UPDATE_NEW_EMAIL_TEMPLATE] (state, emailTemplate) {
    state.newSingleAlert.emailTemplates.filter(el => el.id === null)[0].id = emailTemplate.id
  },
  [SAVE_LAST_DELETED_DATA_SET_ID] (state, id) {
    state.lastDeletedDataSetId = id
  },
  [SAVE_LAST_DELETED_EMAIL_TEMPLATE_ID] (state, id) {
    state.lastDeletedEmailTemplateId = id
  },
  [SAVE_LAST_DELETED_ALERT_ID] (state, id) {
    state.lastDeletedAlertId = id
  },
  [HIDE_ALERT_BY_ID] (state, id) {
    state.newAlerts.filter(el => el.id === id)[0].isHidden = true
  },
  [SHOW_ALERT_BY_ID] (state, id) {
    state.newAlerts.filter(el => el.id === id)[0].isHidden = false
  },
  [HIDE_DATA_SET_BY_ID] (state, id) {
    state.newSingleAlert.dataSets.filter(el => el.id === id)[0].isDeleted = true
  },
  [SHOW_DATA_SET_BY_ID] (state, id) {
    state.newSingleAlert.dataSets.filter(el => el.id === id)[0].isDeleted = false
  },
  [HIDE_EMAIL_TEMPLATE_BY_ID] (state, id) {
    state.newSingleAlert.emailTemplates.filter(el => el.id === id)[0].isDeleted = true
  },
  [SHOW_EMAIL_TEMPLATE_BY_ID] (state, id) {
    state.newSingleAlert.emailTemplates.filter(el => el.id === id)[0].isDeleted = false
  },
  [SET_DATA_SET_PROPERTIES] (state, ds) {
    state.newSingleAlert.dataSets.filter(el => !el.id)[0].processSeq = ds.ps
    state.newSingleAlert.dataSets.filter(el => !el.id)[0].id = ds.id
  },
  [SET_STUDENT_AFFECTED_COUNT] (state, count) {
    state.studentAffectedCount = count
  },
  [UPDATE_DATA_SET_PROP] (state, item) {
    state.newSingleAlert.dataSets[item.key][item.prop] = item.val
  },
  [UPDATE_TEMPLATE_PROP] (state, item) {
    state.newSingleAlert.emailTemplates[item.key][item.prop] = item.val
  },
  [SHOW_ALL_DATA_SETS] (state, visible) {
    Object.keys(state.newSingleAlert.dataSets).forEach(el => {
      state.newSingleAlert.dataSets[el].visible = visible
    })
  },
  [SHOW_ALL_TEMPLATES] (state, visible) {
    Object.keys(state.newSingleAlert.emailTemplates).forEach(el => {
      state.newSingleAlert.emailTemplates[el].visible = visible
    })
  },
  [SET_TEMPLATE_ITEM_VISIBILITY] (state, template) {
    state.newSingleAlert.emailTemplates[template.key].visible = template.visible
  },
  [CONCAT_TEMPLATE_RECIPIENT_TYPES] (state, type) {
    state.templateRecipientTypes = state.templateRecipientTypes.concat(type)
  },
  [SET_DATA_SET_ITEM_VISIBILITY] (state, dataSet) {
    state.newSingleAlert.dataSets[dataSet.key].visible = dataSet.visible
  },
  [CLEAR_ALERT_FILTERS] (state) {
    state.alertFilterFields = clearFilters(state.alertFilterFields)
  },
  [SET_ALERT_BUTTON_FILTER_TYPE] (state, {status, alertFilterObject}) {
    let filterObject = {}
    filterObject.filterName = alertFilterObject.filterIdentifier
    filterObject.id = 0
    filterObject.header = alertFilterObject.filterAdditionalDescription
    filterObject.values = {}
    Object.keys(status).forEach((filter) => {
      filterObject.values[status[filter].code] = {}
      filterObject.values[status[filter].code].value = false
      filterObject.values[status[filter].code].text = status[filter].description
    })
    Vue.set(state.alertFilterFields, filterObject.filterName, filterObject)
  },
  [SET_ALERT_LIST_FILTER_TYPE] (state, {status, alertFilterObject}) {
    let filterObject = {}
    let filterIdentifier = alertFilterObject.filterIdentifier
    filterObject.filterName = filterIdentifier
    filterObject[filterIdentifier] = {}
    filterObject[filterIdentifier].id = 0
    filterObject[filterIdentifier].header = alertFilterObject.filterAdditionalDescription
    filterObject[filterIdentifier].isList = true
    filterObject[filterIdentifier].listName = filterIdentifier
    filterObject[filterIdentifier].values = {}
    filterObject[filterIdentifier][filterIdentifier] = []
    let filterListArray = filterObject[filterIdentifier][filterIdentifier]

    let iterator = status.keys()
    for (let key of iterator) {
      filterObject[filterIdentifier].values[status[key].code] = {}
      filterObject[filterIdentifier].values[status[key].code].value = false
      filterObject[filterIdentifier].values[status[key].code].text = status[key].description

      let filterListObject = {}
      filterListObject.id = key
      filterListObject.description = status[key].description
      filterListObject.identifier = status[key].code
      filterListArray.push(filterListObject)
    }
    Vue.set(state.alertFilterFields, filterObject.filterName, filterObject[filterObject.filterName])

    let source = {}
    source[filterIdentifier] = {}
    source[filterIdentifier].identifier = filterIdentifier
    source[filterIdentifier].title_i18n = alertFilterObject.filterName
    source[filterIdentifier].items = filterListArray
    source[filterIdentifier].idValues = {}
    source[filterIdentifier].button_i18n = '{count} ' + alertFilterObject.filterName + ' ::: {count} ' + alertFilterObject.filterAdditionalDescription
    source[filterIdentifier].button_unselected_i18n = alertFilterObject.filterAdditionalDescription
    source[filterIdentifier].containsText = function containsText (item, text) {
      return (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
        (item.identifier.toUpperCase().indexOf(text.toUpperCase()) >= 0)
    }
    source[filterIdentifier].key = function key (item) {
      return item.identifier
    }
    source[filterIdentifier].mapRow = function mapRow (item) {
      return {
        rows: [item.description, item.identifier],
        id: item.identifier
      }
    }
    Vue.set(state.alertListSources, filterIdentifier, source[filterIdentifier])
  },
  [SET_ALERT_CUSTOM_BUTTON_FILTER_TYPE] (state, {filters, filter, filterIdentifier}) {
    let filterObject = {}
    filterObject.filterName = filterIdentifier
    filterObject.id = 0
    filterObject.header = filters[filter].description
    filterObject.values = {}

    Object.keys(filters[filter]['filterTypeCodes']).forEach((filterValue) => {
      let filterTypeCodes = filters[filter]['filterTypeCodes'][filterValue]
      filterObject.values[filterTypeCodes.code] = {}
      filterObject.values[filterTypeCodes.code].value = false
      filterObject.values[filterTypeCodes.code].text = filterTypeCodes.description
    })
    Vue.set(state.alertFilterFields, filterObject.filterName, filterObject)
  },
  [SET_ALERT_CUSTOM_LIST_FILTER_TYPE] (state, {filters, filter, filterIdentifier}) {
    let filterObject = {}
    filterObject.filterName = filterIdentifier
    filterObject[filterIdentifier] = {}
    filterObject[filterIdentifier].id = 0
    filterObject[filterIdentifier].header = filters[filter]['additionalDescription']
    filterObject[filterIdentifier].isList = true
    filterObject[filterIdentifier].listName = filterIdentifier
    filterObject[filterIdentifier].values = {}
    filterObject[filterIdentifier][filterIdentifier] = []
    let filterListArray = filterObject[filterIdentifier][filterIdentifier]

    Object.keys(filters[filter]['filterTypeCodes']).forEach((filterValue) => {
      let filterTypeCodes = filters[filter]['filterTypeCodes'][filterValue]
      filterObject[filterIdentifier].values[filterTypeCodes.code] = {}
      filterObject[filterIdentifier].values[filterTypeCodes.code].value = false
      filterObject[filterIdentifier].values[filterTypeCodes.code].text = filterTypeCodes.description

      let filterListObject = {}
      filterListObject.id = filterTypeCodes.id
      filterListObject.description = filterTypeCodes.description
      filterListObject.identifier = filterTypeCodes.code
      filterListArray.push(filterListObject)
    })
    Vue.set(state.alertFilterFields, filterObject.filterName, filterObject[filterObject.filterName])

    let source = {}
    source[filterIdentifier] = {}
    source[filterIdentifier].identifier = filterIdentifier
    source[filterIdentifier].title_i18n = filters[filter].description
    source[filterIdentifier].items = filterListArray
    source[filterIdentifier].idValues = {}
    source[filterIdentifier].button_i18n = '{count} ' + filters[filter]['description'] + ' ::: {count} ' + filters[filter]['additionalDescription']
    source[filterIdentifier].button_unselected_i18n = filters[filter]['additionalDescription']
    source[filterIdentifier].containsText = function containsText (item, text) {
      return (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
        (item.identifier.toUpperCase().indexOf(text.toUpperCase()) >= 0)
    }
    source[filterIdentifier].key = function key (item) {
      return item.identifier
    }
    source[filterIdentifier].mapRow = function mapRow (item) {
      return {
        rows: [item.description, item.identifier],
        id: item.identifier
      }
    }
    Vue.set(state.alertListSources, filterIdentifier, source[filterIdentifier])
  },
  [SET_COURSES_FOR_ALERTS_FROM_ENDPOINT] (state, courses) {
    state.alertFilterFields.courseIds.courses = courses
    state.alertListSources.courseIds.items = courses
  },
  [SET_COURSES_FOR_ALERTS_FROM_CHANGE] (state) {
    let filters = getAppliedFilters(state.alertFilterFields)
    state.newSingleAlert.courseIds = filters.courseIds ? filters.courseIds : []
  },
  [SET_STUDY_MODE_FOR_ALERT_FROM_CHANGE] (state) {
    let filters = getAppliedFilters(state.alertFilterFields)
    state.newSingleAlert.studyModes = filters.studyModes ? filters.studyModes : []
  },
  [SET_ALERT_ACADEMIC_YEAR] (state) {
    let filters = getAppliedFilters(state.alertFilterFields)
    state.newSingleAlert.courseYears = filters.courseYears ? filters.courseYears : []
  },
  [SET_ALERT_ENROLMENT_STATUS] (state) {
    let filters = getAppliedFilters(state.alertFilterFields)
    state.newSingleAlert.enrolmentStatus = filters.enrolmentStatus ? filters.enrolmentStatus : []
  },
  [SET_ALERT_COURSE_LEVEL] (state) {
    let filters = getAppliedFilters(state.alertFilterFields)
    state.newSingleAlert.courseLevels = filters.courseLevels ? filters.courseLevels : []
  },
  [TOGGLE_ALERTS_FILTER] (state, {filterType, filterName}) {
    state.alertFilterFields[filterType].values[filterName].value = !state.alertFilterFields[filterType].values[filterName].value
  },
  [SET_ALERT_LIST_FILTER_ARRAY] (state, {filterName, filterType}) {
    let items = {}
    filterName.forEach(item => {
      items[item] = {value: true}
    })
    state.alertFilterFields[filterType].values = items
    state.alertListSources[filterType].idValues = items
  },
  [SET_CUSTOM_ALERT_FILTERS] (state, filterType) {
    let filters = getAppliedFilters(state.alertFilterFields)
    let aFilters = state.newSingleAlert.filters ? state.newSingleAlert.filters : []

    refresh(aFilters, filterType)
    // check if filter is empty, then apply back to alert filter object
    if (filters[filterType]) {
      let element = {}
      element['filterCodes'] = filters[filterType]
      element['filterIdentifier'] = filterType
      aFilters.push(element)
    }
    // re-assign
    state.newSingleAlert.filters = aFilters
  },
  /*
  **
  **
  **
  **
  **
  **
  **
  **
  TODO: SORT OLD CODE BELOW
  */
  [SET_ALERT_FILTER_ID] (state, alerts) {
    Object.keys(alerts).forEach((key) => {
      let id = alerts[key].id
      Vue.set(state.filterFields, id, {})
      Vue.set(state.listSources, id, {})
    })
  },
  [POPULATE_ADMIN_ALERTS] (state, alerts) {
    let ob = alerts.reduce(serverToLocal, {})
    Object.keys(ob).forEach((alert) => {
      for (let key in ob[alert].customFilters) {
        if (ob[alert].customFilters[key]) {
          let filterObject = ob[alert].customFilters[key]
          filterObject.forEach((prop) => {
            if (key !== 'filters') {
              if (state.filterFields[alert][key]) {
                state.filterFields[alert][key].values[prop].value = !state.filterFields[alert][key].values[prop].value
              }
            } else {
              if (state.filterFields[alert][prop.filterIdentifier]) {
                state.filterFields[alert][prop.filterIdentifier].values[prop.code].value = !state.filterFields[alert][prop.filterIdentifier].values[prop.code].value
              }
            }
          })
        }
      }
    })
    state.alerts = ob
  },
  [SET_CUSTOM_FILTERS_ARRAY] (state, {object, key, alertId}) {
    let element = {}
    element['filterCodes'] = object
    element['filterIdentifier'] = key
    state.alerts[alertId].filters.push(element)
  },
  [RESET_ALERT_FILTERS] (state, {id}) {
    state.alerts[id].filters = []
  },
  [SET_ADMIN_ALERT_LAST_UPDATED] (state, {lastUpdated, id}) {
    state.alerts[id].lastUpdated = moment(lastUpdated).format(timeFormat)
  },
  [SET_ADMIN_ALERT_START_DATE] (state, {start, id}) {
    state.alerts[id].dateRange.startDate = start
  },
  [SET_ADMIN_ALERT_END_DATE] (state, {end, id}) {
    state.alerts[id].dateRange.endDate = end
  },
  [SET_ADMIN_ALERT_AFFECTED_COUNT] (state, {affected, id}) {
    state.alerts[id].affectedStudents = affected
  },
  [TOGGLE_ADMIN_ALERT_STATE] (state, alertId) {
    state.alerts[alertId].isOpen = !state.alerts[alertId].isOpen
  },
  [SET_ADMIN_ALERT_SLIDER] (state, {sliderValues, id}) {
    state.alerts[id].sliderValues = sliderValues
  },
  [SET_ADMIN_ALERT_DAYS] (state, {days, id}) {
    state.alerts[id].days = days
  },
  [SET_ADMIN_ALERT_DATE_RANGE] (state, {dateRange, id}) {
    state.alerts[id].startDate = dateRange.startDate
    state.alerts[id].endDate = dateRange.endDate
  },
  [SET_ADMIN_ALERT_NAME] (state, {name, id}) {
    state.alerts[id].name = name
  },
  [SET_ADMIN_ALERT_ACTIVE] (state, {isActive, id}) {
    state.alerts[id].isActive = isActive
  },
  [POPULATE_ADMIN_ALERT_EMAILS] (state, data) {
    let emails = data.map(data => data.emailTemplates)
    emails = flattenArray(emails)
    state.alertEmails = emails.reduce(reduceEmails, {})
  },
  [UPDATE_ADMIN_ALERT_EMAIL_RECIPIENTS] (state, {recipients, id}) {
    state.alertEmails[id].recipients = recipients
  },
  [UPDATE_ADMIN_ALERT_EMAIL_TEXT] (state, {text, id}) {
    state.alertEmails[id].text = text
  },
  [ADD_EMAIL_TEMPLATE_TO_EMAILS_ARRAY] (state, data) {
    Vue.set(state.alertEmails, data.id, serverEmailsToLocal(data))
  },
  [ADD_EMAIL_TEMPLATE_TO_ALERT] (state, data) {
    state.alerts[data.alertId].emails.push(data.id)
  },
  [SET_ADMIN_ALERT_EMAIL_EDITED_STATE] (state, {emailId, edited}) {
    state.alertEmails[emailId].isEdited = edited
  },
  [SET_ALERT_HIERARCHY_DRAWER_STATE] (state, open) {
    state.alertHierarchyDrawer = open
  },
  [SET_ALERT_EDITING] (state, id) {
    state.alertId = id
  },
  [SET_ALERT_COURSES] (state, courses) {
    state.newSingleAlert.courseIds = courses !== null ? courses : []
  },
  [HIDE_ADMIN_ALERT_EMAIL_BY_ID] (state, emailId) {
    state.alertEmails[emailId].isDeleted = true
  },
  [SHOW_ADMIN_ALERT_EMAIL_BY_ID] (state, emailId) {
    state.alertEmails[emailId].isDeleted = false
  },
  [SET_LAST_DELETED_ADMIN_ALERT_EMAIL_ID] (state, emailId) {
    state.lastDeletedAlertEmailId = emailId
  },
  [UPDATE_ALERT] (state, alert) {
    const isOpen = state.alerts[alert.id].isOpen
    serverToLocal(state.alerts, alert)
    state.alerts[alert.id].isOpen = isOpen
  },
  [SET_ALERT_BUTTON_FILTER_ARRAY] (state, {filterName, filterType, filterId}) {

  }
}

const getters = {
  GET_ADMIN_ALERT_EMAILS: (state) => (alertId) => {
    return state.alerts[alertId].emails
      .map(emailId => state.alertEmails[emailId])
      .filter(email => !email.isDeleted)
  },
  [GET_ALERT]: (state) => {
    return state.alerts[state.alertId]
  }
}

const refresh = (array, identifier) => {
  // locate filter we have amended
  const index = array.findIndex(i => i.filterIdentifier === identifier)
  // remove if index exists
  if (index !== -1) {
    array.splice(index, 1)
  }
}
const setDataSetDefaults = (obj) => {
  obj.description = ''
  obj.editorDescription = ''
  obj.visible = true
  obj.submitted = true
  obj.isDeleted = false
}

const setTemplateDefaults = (obj) => {
  let selectionType = obj.emailRecipients.map(el => {
    if (el.emailRecipientType === 'FREESTYLE') {
      return el.email
    } else {
      return el.emailRecipientType
    }
  })
  obj.emailRecipients = selectionType
  obj.editorTemplateName = ''
  obj.visible = true
  obj.submitted = true
  obj.isDeleted = false
}

export const mapFreestyleRecipients = (obj) => {
  return obj.filter(el => el.emailRecipientType === 'FREESTYLE').map(el => {
    return {
      text: el.email,
      value: el.email
    }
  })
}

const serverToLocaleCustomFilters = (a) => {
  if (a.filterCodes) {
    a.filters = []

    let keys = a.filterCodes.map(el => el.filterIdentifier).filter(distinct)
    keys.forEach(el => {
      let obj = a.filterCodes.filter(f => f.filterIdentifier === el)

      let element = {}
      element['filterCodes'] = obj.map(o => o.code)
      element['filterIdentifier'] = el
      a.filters.push(element)
    })
  }
}

const distinct = (value, index, self) => {
  return self.indexOf(value) === index
}

// const newLocalToServer = (al) => {
//   return {
//     id: al.id,
//     active: al.active,
//     consecutiveDays: al.consecutiveDays,
//     courseLevels: al.courseLevels,
//     courseYears: al.courseYears,
//     courses: al.courses,
//     effectiveFromDateInclusive: al.effectiveFromDateInclusive,
//     emailTemplates: al.emailTemplates,
//     endDateExclusive: al.endDateExclusive,
//     enrolmentStatus: al.enrolmentStatus,
//     filterCodes: al.filterCodes,
//     dataSets: al.dataSets,
//     lastUpdated: al.lastUpdated,
//     name: al.name,
//     frequencyDays: al.frequencyDays,
//     positive: al.positive,
//     studyModes: al.studyModes
//   }
// }

const resetAlert = () => {
  return {
    filterValue: null,
    thresholdCondition: null,
    minThreshold: null,
    maxThreshold: null,
    consecutiveDays: null
  }
}

const getVal = (val) => {
  return val === undefined ? null : val
}

const dataSetToServer = (a) => {
  return {
    dataSetId: getVal(a.dataSetItem.id),
    filterValue: getVal(a.filterValue),
    processSeq: getVal(a.processSeq),
    thresholdCondition: getVal(a.thresholdCondition),
    minThreshold: getVal(a.minThreshold),
    maxThreshold: getVal(a.maxThreshold),
    logic: getVal(a.logic),
    consecutiveDays: getVal(a.consecutiveDays)
  }
}

const newDataSet = () => {
  return {
    dataSetId: null,
    filterValue: null,
    processSeq: null,
    thresholdCondition: null,
    minThreshold: null,
    maxThreshold: null,
    logic: null,
    logicColour: null,
    consecutiveDays: null,
    dataSetItem: {},
    visible: true,
    submitted: false,
    isDeleted: false
  }
}

const newEmailTemplate = () => {
  return {
    id: null,
    subjectText: null,
    templateName: null,
    templateText: null,
    emailRecipients: [],
    deliveryMethods: [],
    deleted: false,
    visible: true,
    submitted: false,
    isDeleted: false
  }
}

const newDefaultAlert = () => {
  return {
    id: 0,
    name: null,
    effectiveFromDateInclusive: moment().format('YYYY-MM-DD'),
    endDateExclusive: moment().format('YYYY-MM-DD'),
    active: false,
    consecutiveDays: 1,
    deleted: false
  }
}

const serverToLocal = (acc, a) => {
  acc[a.id] = {
    id: a.id,
    name: a.name,
    sliderValues: [ratingMap[a.minEngagementRating], ratingMap[a.maxEngagementRating]],
    days: a.consecutiveDays,
    dateRange: {
      startDate: moment(a.effectiveFromDateInclusive).format(format),
      endDate: moment(a.endDateExclusive).format(format)
    },
    isOpen: false,
    isActive: a.active,
    emails: a.emailTemplates.map(email => email.id),
    lastUpdated: moment(a.lastUpdated).format(timeFormat),
    hierarchyId: a.hierarchyId,
    affectedStudents: a.studentsAffectedCount,
    courses: a.courses,
    courseYears: a.courseYears,
    enrolmentStatus: a.enrolmentStatus,
    studyModes: a.studyModes,
    courseLevels: a.courseLevels,
    filters: a.filterCodes,
    customFilters: {
      courseYears: a.courseYears,
      enrolmentStatus: a.enrolmentStatus,
      studyModes: a.studyModes,
      courseLevels: a.courseLevels,
      filters: a.filterCodes
    }
  }
  return acc
}

const flattenArray = list => list.reduce(
  (a, b) => a.concat(Array.isArray(b) ? flattenArray(b) : b), []
)

const reduceEmails = (acc, e) => {
  acc[e.id] = serverEmailsToLocal(e)
  return acc
}

const serverEmailsToLocal = (email) => {
  return {
    id: email.id,
    text: email.templateText,
    recipients: flattenEmailRecipients(email.emailRecipients),
    isEdited: false,
    isDeleted: false
  }
}

const localEmailToServer = (email) => {
  return {
    id: email.id,
    templateText: email.text,
    emailRecipients: email.recipients
      .map(recipient => {
        return {
          emailRecipientType: recipient
        }
      })
  }
}

const convertEmailToServer = (email) => {
  return {
    id: email.id,
    deleted: email.deleted,
    subjectText: email.subjectText,
    templateName: email.templateName,
    templateText: email.templateText,
    emailRecipients: email.emailRecipients
      .map(recipient => {
        if (recipient.includes('@')) {
          return {
            emailRecipientType: 'FREESTYLE',
            email: recipient
          }
        } else {
          return {
            emailRecipientType: recipient,
            email: null
          }
        }
      }),
    deliveryMethod: email.deliveryMethod
  }
}

const flattenEmailRecipients = list => list.reduce(
  (acc, recipient) => acc.concat(recipient.emailRecipientType), [])

const localToServer = (a) => {
  return {
    id: a.id,
    name: a.name,
    minEngagementRating: getReverseRatingMap(ratingMap)[a.sliderValues[0]],
    maxEngagementRating: getReverseRatingMap(ratingMap)[a.sliderValues[1]],
    consecutiveDays: a.days,
    effectiveFromDateInclusive: moment(a.dateRange.startDate, format).valueOf(),
    endDateExclusive: moment(a.dateRange.endDate, format).valueOf(),
    hierarchyId: a.hierarchyId,
    active: a.isActive,
    courseIds: a.courseIds,
    courseYears: a.courseYears,
    enrolmentStatus: a.enrolmentStatus,
    studyModes: a.studyModes,
    courseLevels: a.courseLevels,
    filters: a.filters
  }
}

// const customFilterButton = (object) => {
//   let objectValues = {}
//   Object.keys(object.values).forEach((objectValueKey) => {
//     let objectValue = {}
//     objectValue[objectValueKey] = {
//       value: false,
//       text: object.values[objectValueKey].text
//     }
//     Vue.set(objectValues, objectValueKey, objectValue[objectValueKey])
//   })
//   let customObject = {
//     filterName: object.filterName,
//     header: object.header,
//     values: objectValues
//   }
//   return customObject
// }

// const customFilterList = (object) => {
//   let objectValues = {}
//   let filterIdentifier = object.filterName
//   Object.keys(object[filterIdentifier].values).forEach((objectValueKey) => {
//     debugger
//     let objectValue = {}
//     objectValue[objectValueKey] = {
//       value: false,
//       text: object[filterIdentifier].values[objectValueKey].text
//     }
//     debugger
//     Vue.set(objectValues, objectValueKey, objectValue[objectValueKey])
//     debugger
//   })
//   let customObject = {
//     filterName: filterIdentifier,
//     header: object[filterIdentifier].header,
//     values: objectValues,
//     listName: filterIdentifier,
//     isList: true
//   }
//   debugger
//   return customObject
// }

// const customListSource = (object) => {
//   let identifier = object.identifier
//   let customObject = {
//     identifier: identifier,
//     title_i18n: object.title_i18n,
//     items: object.items,
//     idValues: object.idValues,
//     button_i18n: object.button_i18n,
//     button_unselected_i18n: object.button_unselected_i18n,
//     containsText: object.containsText,
//     key: object.key,
//     mapRow: object.mapRow
//   }
//   return customObject
// }

const getReverseRatingMap = (ratingMap) => {
  let ret = {}
  for (let key in ratingMap) {
    ret[ratingMap[key]] = key
  }
  return ret
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/admin.js